import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from './lib/theme';
import { RecoilRoot } from 'recoil';
import Router from './Router';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <RecoilRoot>
        <Router />
      </RecoilRoot>
    </ThemeProvider>
  );
}

export default App;
